// src/config/blockThemes.js

// Legacy theme names that should fall back to lightgrey
const LEGACY_THEME_NAMES = [
  'default',
  'medblue', 
  'darkblue',
  'charcoal',
];

const blockThemes = [
  {
    style: {
      '--theme-color': 'white',
      '--theme-high-contrast-color': 'var(--charcoal)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--mediumdarkgrey)',
    },
    name: 'default',
    label: 'Default',
  },
  // Light Grey (replaces old default)
  {
    style: {
      '--theme-color': 'var(--lightgrey)',
      '--theme-high-contrast-color': 'var(--charcoal)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--mediumdarkgrey)',
      '--link-foreground-color': 'var(--blue-base)',
    },
    name: 'lightgrey',
    label: 'Light Grey',
  },

  // Warmer Ocean Blue - Tint 10% variant
  {
    style: {
      '--theme-color': 'var(--blue-tint-10)',
      '--theme-high-contrast-color': 'var(--blue-highcontrast)',
      '--theme-foreground-color': 'var(--blue-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--blue-base)',
      '--link-foreground-color': 'var(--blue-base)',
    },
    name: 'blue-tint-10',
    label: 'Ocean Blue (Lightest)',
  },

  // Warmer Ocean Blue - Tint 20% variant
  {
    style: {
      '--theme-color': 'var(--blue-tint-20)',
      '--theme-high-contrast-color': 'var(--blue-highcontrast)',
      '--theme-foreground-color': 'var(--blue-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--blue-darker)',
      '--link-foreground-color': 'var(--blue-base)',
    },
    name: 'blue-tint-20',
    label: 'Ocean Blue (Light)',
  },

  // Deeper Teal - Tint 10% variant
  {
    style: {
      '--theme-color': 'var(--teal-tint-10)',
      '--theme-high-contrast-color': 'var(--teal-highcontrast)',
      '--theme-foreground-color': 'var(--teal-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--teal-base)',
      '--link-foreground-color': 'var(--teal-base)',
    },
    name: 'teal-tint-10',
    label: 'Teal (Lightest)',
  },

  // Deeper Teal - Tint 20% variant
  {
    style: {
      '--theme-color': 'var(--teal-tint-20)',
      '--theme-high-contrast-color': 'var(--teal-highcontrast)',
      '--theme-foreground-color': 'var(--teal-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--teal-base)',
      '--link-foreground-color': 'var(--teal-base)',
    },
    name: 'teal-tint-20',
    label: 'Teal (Light)',
  },

  // Vibrant Turquoise - Tint 10% variant
  {
    style: {
      '--theme-color': 'var(--turquoise-tint-10)',
      '--theme-high-contrast-color': 'var(--turquoise-highcontrast)',
      '--theme-foreground-color': 'var(--turquoise-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--turquoise-base)',
      '--link-foreground-color': 'var(--turquoise-highcontrast)',
    },
    name: 'turquoise-tint-10',
    label: 'Turquoise (Lightest)',
  },

  // Vibrant Turquoise - Tint 20% variant
  {
    style: {
      '--theme-color': 'var(--turquoise-tint-20)',
      '--theme-high-contrast-color': 'var(--turquoise-highcontrast)',
      '--theme-foreground-color': 'var(--turquoise-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--turquoise-base)',
      '--link-foreground-color': 'var(--turquoise-highcontrast)',
    },
    name: 'turquoise-tint-20',
    label: 'Turquoise (Light)',
  },

  // Deeper Gold - Tint 10% variant
  {
    style: {
      '--theme-color': 'var(--gold-tint-10)',
      '--theme-high-contrast-color': 'var(--gold-highcontrast)',
      '--theme-foreground-color': 'var(--gold-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--gold-darker)',
      '--link-foreground-color': 'var(--gold-highcontrast)',
    },
    name: 'gold-tint-10',
    label: 'Gold (Lightest)',
  },

  // Deeper Gold - Tint 20% variant
  {
    style: {
      '--theme-color': 'var(--gold-tint-20)',
      '--theme-high-contrast-color': 'var(--gold-highcontrast)',
      '--theme-foreground-color': 'var(--gold-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--gold-darker)',
      '--link-foreground-color': 'var(--gold-highcontrast)',
    },
    name: 'gold-tint-20',
    label: 'Gold (Light)',
  },

  // Earthy Coral - Tint 10% variant
  {
    style: {
      '--theme-color': 'var(--coral-tint-10)',
      '--theme-high-contrast-color': 'var(--coral-highcontrast)',
      '--theme-foreground-color': 'var(--coral-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--coral-darker)',
      '--link-foreground-color': 'var(--coral-darker)',
    },
    name: 'coral-tint-10',
    label: 'Coral (Lightest)',
  },

  // Earthy Coral - Tint 20% variant
  {
    style: {
      '--theme-color': 'var(--coral-tint-20)',
      '--theme-high-contrast-color': 'var(--coral-highcontrast)',
      '--theme-foreground-color': 'var(--coral-highcontrast)',
      '--theme-low-contrast-foreground-color': 'var(--coral-darker)',
      '--link-foreground-color': 'var(--coral-darker)',
    },
    name: 'coral-tint-20',
    label: 'Coral (Light)',
  },
];

// Add legacy theme fallbacks that point to lightgrey
LEGACY_THEME_NAMES.forEach((legacyName) => {
  const lightgreyTheme = blockThemes.find(t => t.name === 'lightgrey');
  if (lightgreyTheme && !blockThemes.find(t => t.name === legacyName)) {
    blockThemes.push({
      ...lightgreyTheme,
      name: legacyName,
      label: `${legacyName.charAt(0).toUpperCase() + legacyName.slice(1)} (Legacy)`,
    });
  }
});

export default blockThemes;
